// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2yoNM","label":"Section_label__3OKly","contentWrap":"Section_contentWrap__1WE33","footer":"Section_footer__8GKE5","footerInner":"Section_footerInner__8fv9w"};